import React, { PureComponent } from 'react';
import { Alert, message } from 'antd';
import get from 'lodash/get';
import config from '$config';
import Copyable from '$app/shared/components/Copyable';
import Modal from '../../../../../components/Modal';
import { generateCustomerInvoice } from '../api';
import BookingPageContext from '../../../context';

class GenerateInvoiceModal extends PureComponent {
  static contextType = BookingPageContext;

  state = {
    confirmLoading: false,
  };

  handleOk = async () => {
    const { authUser, booking, closePopup } = this.props;
    const { name, surname, username } = authUser;
    const author = name && surname ? `${name} ${surname}` : username;

    try {
      this.setState({ confirmLoading: true });
      message.loading('Please wait for a few seconds...', 20);

      const response = await generateCustomerInvoice(booking.bookingId, author);

      if (response?.status === 200) {
        const baseUrl = booking.segment === 'FIXTER-UK' ? config.landingUrl : config.landingUrlFr;
        message.success(
          <>
            Invoice has been generated and can be accessed in the customer&apos;s account
            <Copyable value={`${baseUrl}customer/bookings/${booking.bookingId}`} />
          </>,
          10
        );
        closePopup();
        this.context.reloadBooking();
      } else {
        message.error('Failed to generate customer invoice');
        this.setState({ confirmLoading: false });
      }
    } catch (error) {
      message.error(get(error, 'response.data.message', error.message) || 'Failed to generate customer invoice');
      this.setState({ confirmLoading: false });
    }
  };

  render() {
    const { closePopup, openedPopup } = this.props;

    return (
      <Modal
        title="Are you sure you want to generate this invoice manually?"
        visible={openedPopup === 'GenerateInvoiceModal'}
        onOk={this.handleOk}
        onCancel={closePopup}
        cancelText="No"
        okText="Yes"
        confirmLoading={this.state.confirmLoading}
      >
        <Alert
          type="warning"
          message="
            Manual invoice generation should only be used in specific cases where the normal invoice email
            flow is not applicable. Details reflected on the invoice that change after this step will require
            another invoice to be generated.
          "
        />
      </Modal>
    );
  }
}

export default GenerateInvoiceModal;
